import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, List, Typography, Button, Empty } from "antd";
import moment from "moment";
import { fetchViewHistory } from "PlatForms/OrgLMS/Services/LearnerService/trainingDetailService";

const { Title, Text } = Typography;

const ViewHistory = () => {
  const location = useLocation();
  const { memberID } = location.state || {};
  const token = localStorage.getItem("token");
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (memberID) {
      fetchHistory();
    }
  }, [memberID]);

  const fetchHistory = async () => {
    try {
      const data = await fetchViewHistory(memberID, token);
      setHistoryData(data);
      if (typeof window.updateBadgeCount === "function") {
        window.updateBadgeCount();
      }
    } catch (error) {
      console.error("Error fetching report status:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className="card-professional"
      loading={loading}
      title="View Issue History"
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {historyData.length === 0 ? (
        <Empty description="No history found for this member" />
      ) : (
        historyData.map((entry) => (
          <Card
            key={entry.id}
            style={{ marginBottom: 20, background: "#fafafa", borderRadius: 10 }}
          >
            <Title level={4} style={{ color: "#9A6B0E", marginBottom: 10 }}>
              {entry.category}
            </Title>
            <Text type="secondary" style={{ fontSize: "14px" }}>
              Created on: {moment(entry.createdAt).format("MMMM Do YYYY, h:mm A")}
            </Text>

            <List
              bordered
              dataSource={entry.questions}
              style={{ marginTop: 10 }}
              renderItem={(item) => (
                <List.Item style={{ padding: "15px", display: "block" }}>
                  <Text strong style={{ fontSize: "16px", color: "#333" }}>
                    Q: {item.question}
                  </Text>
                  <br />
                  <Text style={{ fontSize: "14px", color: "#555" }}>A: {item.answer}</Text>
                </List.Item>
              )}
            />

            <Text
              strong
              style={{ fontSize: "15px", color: "#8C6400", marginTop: "10px", display: "block" }}
            >
              Mentor Feedback:
            </Text>
            <Text style={{ fontSize: "14px", color: "#333", display: "block" }}>
              {entry.mentorFeedback ? entry.mentorFeedback.feedback : "N/A"}
            </Text>
          </Card>
        ))
      )}
    </Card>
  );
};

export default ViewHistory;
